import React, { useContext } from "react";
import { useState, useEffect } from "react";
import "../../Tabels/Tabels.css";
import { Link } from "react-router-dom";
import { Context } from "../../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faAngleLeft, fas } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleInfo } from "@fortawesome/free-solid-svg-icons";
// *******************toster****************************
import Select from "react-select";
import ModalSave from "../../common/ModelSave";
import Validation from "../../common/FormValidation";
import { CancelButton, SaveButton } from "../../common/Button";

import { Row, Col, Form, InputGroup, Modal } from "react-bootstrap";
import { useForm, Controller, useFieldArray } from "react-hook-form";
import classNames from "classnames";
import { putData } from "../../../utils/api";
import { SelectImageData } from "../../../utils/common";
import { useNavigate } from "react-router";
import Header from "../../Header/Header";
import VarientSection from "./Varient";
import { useParams } from "react-router-dom";
import Loader from "../../common/Loader";

library.add(fas);

const EditOffCanvance = (props) => {
  const navigate = useNavigate();

  // const id = props.show;
  const { id } = useParams();
  const { postData, getData, Select2Data, IMG_URL } = useContext(Context);
  const [countries, setCountries] = useState([]);
  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  const [loading, setLoading] = useState(true);
  const [submitLoading, setSubmitLoading] = useState(false);

  const GetEditData = async () => {
    try {
      setLoading(true);
      const response = await getData(
        `/admin/purchase-order/purchase-product/${id}`,
      );
      reset({
        ...response?.data,
        remark: "",
      });
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const GetAllCategory = async () => {
    const response = await getData("/common/masters/all-p-category");

    if (response?.success) {
      setCountries(await Select2Data(response?.data, "p_category_id"));
    }
  };

  useEffect(() => {
    GetAllCategory();
    GetEditData();
  }, []);

  const {
    control,
    register,
    handleSubmit,
    formState: { errors },
    reset,
    getValues,
    setValue,
    watch,
  } = useForm();

  const Select3Data = async (data, name, other = false) => {
    const result = data?.map((data) => ({
      value: data?.id,
      label: data?.name,
      variant_type_id: data?.variant_type_id,
      name: name,
    }));

    if (other) {
      result.push({ value: "0", label: "Other", name: name });
    }
    return result;
  };
  const [product, setProduct] = useState([]);

  const GetAllProduct = async () => {
    const response = await getData("/common/masters/product");

    if (response?.success) {
      setProduct(await Select3Data(response?.data, "product_id"));
    }
  };

  useEffect(() => {
    GetAllProduct();
  }, []);
  const watchQuantitys = watch("products");

  const totalQuantity =
    watchQuantitys?.reduce((sum, item) => {
      const qty = parseFloat(item?.receive_quantity);
      return sum + (isNaN(qty) ? 0 : qty);
    }, 0) || 0;

  const totalPrice =
    watchQuantitys?.reduce((sum, item) => {
      const qty = parseFloat(item?.receive_quantity);
      const price = parseFloat(item?.price);
      const total = (isNaN(qty) ? 0 : qty) * (isNaN(price) ? 0 : price);
      return sum + total;
    }, 0) || 0;

  const onSubmit = async (data) => {
    try {
      setSubmitLoading(true);
      const DataToSend = new FormData();
      DataToSend.append("id", data?.id);
      DataToSend.append("total_quantity", totalQuantity);
      DataToSend.append("remark", data?.remark);
      DataToSend.append("total_price", totalPrice);
      DataToSend.append("batch_no", data?.batch_no);
      DataToSend.append("expiry_date", data?.expiry_date);
      DataToSend.append("mfg_date", data?.mfg_date);
      DataToSend.append("supplier_id", data?.supplier_id?.value);
      // for (let pair of DataToSend.entries()) {
      //   console.log(pair[0], pair[1]);
      // }

      // return;
      const quantity = [];

      data.products.forEach((val) => {
        const qty = parseFloat(val?.receive_quantity) || 0;
        const price = parseFloat(val?.price) || 0;
        const total = (qty * price).toFixed(2);

        const quantityItem = {
          id: val?.id,
          product_id: val?.product_id?.value,
          variant_id: val?.variant_id?.value,
          quantity: qty,
          expiry_date: val?.expiry_date,
          mfg_date: val?.mfg_date,
          price: price,
          total_price: total,
          varients: [],
        };

        // 🔹 VARIANTS
        val?.varients?.forEach((variant) => {
          const variantItem = {
            product_id: val?.product_id?.value,
            variant_id: variant?.varient_id,
            general_stock: variant?.general_stock || 0,
            selling_price: variant?.selling_price || 0,
            subscription_stock: variant?.subscription_stock || 0,
            double_variants: [],
          };

          // 🔹 DOUBLE VARIANTS
          variant?.double_variants?.forEach((doubleVar) => {
            const doubleItem = {
              d_variant_id: doubleVar?.d_variant_id,
              stock: doubleVar?.stock || 0,
              triple_variants: [],
            };

            // 🔹 TRIPLE VARIANTS
            doubleVar?.triple_variants?.forEach((tripleVar) => {
              doubleItem.triple_variants.push({
                t_variant_id: tripleVar?.t_variant_id,
                stock: tripleVar?.stock || 0,
              });
            });

            variantItem.double_variants.push(doubleItem);
          });

          quantityItem.varients.push(variantItem);
        });

        quantity.push(quantityItem);
      });

      DataToSend.append("products", JSON.stringify(quantity));

      const response = await putData(
        `/admin/purchase-order/purchase-product/receiving/${id}`,
        DataToSend,
      );

      if (response?.success) {
        await setShowModal({
          code: response.code,
          message: response.data || response.message,
        });
      } else {
        await setShowModal({ code: response?.code, message: response?.errors });
      }
      setTimeout(() => {
        setShowModal(0);
        navigate("/purchase-product/purchase-product");
        // props.handleClose();
      }, 1000);
    } catch (error) {
      console.log(error);
    } finally {
      setSubmitLoading(false);
    }
  };

  const { fields, append, remove } = useFieldArray({
    control,
    name: "products",
  });

  const [supplier, setSupplier] = useState([]);
  const GetAllSupplier = async () => {
    const response = await getData("/common/masters/all-supplier");
    if (response?.success) {
      setSupplier(await Select2Data(response?.data, "supplier_id"));
    }
  };
  useEffect(() => {
    GetAllSupplier();
  }, []);

  return (
    <>
      <Header title={"Product Purchase Compare"} link={"#"} />
      <section className="Create">
        <div className="back_btn_holder">
          <div onClick={() => navigate(`/purchase-product/purchase-product`)}>
            <FontAwesomeIcon className="back-btn" icon={faAngleLeft} />
            Back
          </div>
        </div>
        {loading ? (
          <Loader />
        ) : (
          <Form onSubmit={() => handleSubmit(onSubmit)} role="form">
            <Row>
              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Row className="row justify-content-center mb-2">
                    <Form.Label>Supplier</Form.Label>

                    <Controller
                      name="supplier_id" // name of the field
                      {...register("supplier_id", {
                        required: "Select Supplier",
                      })}
                      control={control}
                      render={({ field }) => (
                        <Select
                          styles={{
                            control: (baseStyles) => ({
                              ...baseStyles,
                              borderColor: errors.supplier_id
                                ? "red"
                                : baseStyles,
                            }),
                          }}
                          {...field}
                          options={supplier}
                          // onChange={(selectedOption) => {
                          //   field.onChange(selectedOption.value); // Update Controller's value
                          //   GetAllStates(selectedOption.value);
                          //   setValue("country_id", selectedOption);
                          //   setValue("state_id", null);
                          // }}
                        />
                      )}
                    />

                    {errors.supplier_id && (
                      <span className="text-danger">
                        {errors.supplier_id.message}
                      </span>
                    )}
                  </Row>
                </div>
              </Col>
              <div className="oder-detail-holder mb-3">
                <div className="heading-holder">
                  <h6> Receiving Quantity</h6>
                </div>

                <div className="package-details-section">
                  {fields.map((variant, index) => (
                    <div key={variant.id} className="main-form-section mt-3">
                      <Row>
                        <Col md={4}>
                          <div className="main-form-section mt-3">
                            <Row className="justify-content-center">
                              <Form.Label>Product</Form.Label>
                              <Form.Group>
                                <Controller
                                  name={`products.${index}.product_id`} // name of the field
                                  {...register(`products.${index}.product_id`, {
                                    required: "Select Product",
                                  })}
                                  control={control}
                                  render={({ field }) => (
                                    <Select
                                      isDisabled={true}
                                      styles={{
                                        control: (baseStyles) => ({
                                          ...baseStyles,
                                          borderColor: errors?.add_on?.[index]
                                            ?.product_id
                                            ? "red"
                                            : baseStyles,
                                        }),
                                      }}
                                      {...field}
                                      options={product}
                                    />
                                  )}
                                />
                                {errors?.products?.[index]?.product_id && (
                                  <span className="text-danger">
                                    {errors.products[index].product_id.message}
                                  </span>
                                )}
                              </Form.Group>
                            </Row>
                          </div>
                        </Col>
                        <Col md={4}>
                          <div className="main-form-section mt-3">
                            <Row className="justify-content-center">
                              <Form.Label>Product Variant</Form.Label>
                              <Form.Group>
                                <Controller
                                  name={`products.${index}.variant_id`} // name of the field
                                  {...register(`products.${index}.variant_id`, {
                                    required: "Select Product Variant",
                                  })}
                                  control={control}
                                  render={({ field }) => (
                                    <Select
                                      isDisabled={true}
                                      styles={{
                                        control: (baseStyles) => ({
                                          ...baseStyles,
                                          borderColor: errors?.add_on?.[index]
                                            ?.variant_id
                                            ? "red"
                                            : baseStyles,
                                        }),
                                      }}
                                      {...field}
                                      options={product}
                                    />
                                  )}
                                />
                                {errors?.products?.[index]?.variant_id && (
                                  <span className="text-danger">
                                    {errors.products[index].variant_id.message}
                                  </span>
                                )}
                              </Form.Group>
                            </Row>
                          </div>
                        </Col>
                        <Col md={4}>
                          <div className="main-form-section mt-3">
                            <Row className="justify-content-center">
                              <Form.Label>Purchase Quantity</Form.Label>
                              <Form.Group>
                                <Form.Control
                                  type="text"
                                  name={`products.${index}.quantity`} // Register color for the variant
                                  placeholder="Quantity"
                                  readOnly
                                  className={classNames("", {
                                    "is-invalid":
                                      errors?.products?.[index]?.quantity,
                                  })}
                                  {...register(`products.${index}.quantity`, {
                                    required: "Quantity is required",
                                  })}
                                  onKeyDown={(e) => {
                                    if (
                                      e.key === "Backspace" ||
                                      e.key === "ArrowLeft" ||
                                      e.key === "ArrowRight"
                                    ) {
                                      return; // Allow the action to continue
                                    }

                                    // Allow digits and decimal point
                                    if (!/[\d.]/.test(e.key)) {
                                      e.preventDefault(); // Block the invalid key
                                    }

                                    if (
                                      e.key === "." &&
                                      e.target.value.includes(".")
                                    ) {
                                      e.preventDefault();
                                    }
                                  }}
                                />
                                {errors?.products?.[index]?.quantity && (
                                  <span className="text-danger">
                                    {errors.products[index].quantity.message}
                                  </span>
                                )}
                              </Form.Group>
                            </Row>
                          </div>
                        </Col>
                        <Col md={4}>
                          <div className="main-form-section mt-3">
                            <Row className="justify-content-center">
                              <Form.Label>Received Quantity</Form.Label>
                              <Form.Group>
                                <Form.Control
                                  type="text"
                                  name={`products.${index}.receive_quantity`} // Register color for the variant
                                  placeholder="Received Quantity"
                                  className={classNames("", {
                                    "is-invalid":
                                      errors?.products?.[index]
                                        ?.receive_quantity,
                                  })}
                                  {...register(
                                    `products.${index}.receive_quantity`,
                                    {
                                      required: "Received Quantity is required",
                                      validate: (value) => {
                                        const purchaseQty = Number(
                                          getValues(
                                            `products.${index}.quantity`,
                                          ),
                                        );

                                        return (
                                          Number(value) <= purchaseQty ||
                                          "Received Quantity should not be greater than Purchase Quantity"
                                        );
                                      },
                                    },
                                  )}
                                  onKeyDown={(e) => {
                                    if (
                                      e.key === "Backspace" ||
                                      e.key === "ArrowLeft" ||
                                      e.key === "ArrowRight"
                                    ) {
                                      return; // Allow the action to continue
                                    }

                                    // Allow digits and decimal point
                                    if (!/[\d.]/.test(e.key)) {
                                      e.preventDefault(); // Block the invalid key
                                    }

                                    if (
                                      e.key === "." &&
                                      e.target.value.includes(".")
                                    ) {
                                      e.preventDefault();
                                    }
                                  }}
                                />
                                {errors?.products?.[index]
                                  ?.receive_quantity && (
                                  <span className="text-danger">
                                    {
                                      errors.products[index].receive_quantity
                                        .message
                                    }
                                  </span>
                                )}
                              </Form.Group>
                            </Row>
                          </div>
                        </Col>

                        <Col md={4}>
                          <div className="main-form-section mt-3">
                            <Row className="justify-content-center">
                              <Form.Label>Price</Form.Label>
                              <Form.Group>
                                <Form.Control
                                  type="text"
                                  name={`products.${index}.price`} // Register color for the variant
                                  placeholder="Price"
                                  className={classNames("", {
                                    "is-invalid":
                                      errors?.products?.[index]?.price,
                                  })}
                                  {...register(`products.${index}.price`, {
                                    required: "price is required",
                                  })}
                                  onKeyDown={(e) => {
                                    if (
                                      e.key === "Backspace" ||
                                      e.key === "ArrowLeft" ||
                                      e.key === "ArrowRight"
                                    ) {
                                      return; // Allow the action to continue
                                    }

                                    // Allow digits and decimal point
                                    if (!/[\d.]/.test(e.key)) {
                                      e.preventDefault(); // Block the invalid key
                                    }

                                    if (
                                      e.key === "." &&
                                      e.target.value.includes(".")
                                    ) {
                                      e.preventDefault();
                                    }
                                  }}
                                />
                                {errors?.products?.[index]?.price && (
                                  <span className="text-danger">
                                    {errors.products[index].price.message}
                                  </span>
                                )}
                              </Form.Group>
                            </Row>
                          </div>
                        </Col>

                        <Col md={4}>
                          <div className="main-form-section mt-3">
                            <Row className="justify-content-center">
                              <Form.Label>Total</Form.Label>
                              <Form.Group>
                                <Form.Control
                                  type="text"
                                  name={`products.${index}.total_price`}
                                  value={(() => {
                                    const receiveQty =
                                      parseFloat(
                                        watch(
                                          `products.${index}.receive_quantity`,
                                        ),
                                      ) || 0;
                                    const price =
                                      parseFloat(
                                        watch(`products.${index}.price`),
                                      ) || 0;
                                    return (receiveQty * price).toFixed(2);
                                  })()}
                                  readOnly
                                  className={classNames("", {
                                    "is-invalid":
                                      errors?.products?.[index]?.total_price,
                                  })}
                                />
                                {errors?.products?.[index]?.total_price && (
                                  <span className="text-danger">
                                    {errors.products[index].total_price.message}
                                  </span>
                                )}
                              </Form.Group>
                            </Row>
                          </div>
                        </Col>

                        <Col md={4}>
                          <div className="main-form-section mt-3">
                            <Row className="justify-content-center">
                              <Form.Label>Manufacturing Date</Form.Label>

                              <Form.Group>
                                <Form.Control
                                  type="date"
                                  name={`products.${index}.mfg_date`}
                                  placeholder="Manufacturing Date"
                                  className={classNames("", {
                                    "is-invalid":
                                      errors?.products?.[index]?.mfg_date,
                                  })}
                                  max={new Date().toISOString().split("T")[0]}
                                  {...register(`products.${index}.mfg_date`, {
                                    required: "Manufacturing Date is required",

                                    validate: (value) => {
                                      const mfgDate = new Date(value);

                                      const today = new Date();
                                      today.setHours(0, 0, 0, 0);

                                      return (
                                        mfgDate <= today ||
                                        "Manufacturing Date cannot be a future date"
                                      );
                                    },
                                  })}
                                />

                                {errors?.products?.[index]?.mfg_date && (
                                  <div className="invalid-feedback">
                                    {
                                      errors?.products?.[index]?.mfg_date
                                        ?.message
                                    }
                                  </div>
                                )}
                              </Form.Group>
                            </Row>
                          </div>
                        </Col>

                        <Col md={4}>
                          <div className="main-form-section mt-3">
                            <Row className="justify-content-center">
                              <Form.Label>Expiry Date</Form.Label>

                              <Form.Group>
                                <Form.Control
                                  type="date"
                                  name={`products.${index}.expiry_date`}
                                  placeholder="Expiry Date"
                                  className={classNames("", {
                                    "is-invalid":
                                      errors?.products?.[index]?.expiry_date,
                                  })}
                                  min={new Date().toISOString().split("T")[0]}
                                  {...register(
                                    `products.${index}.expiry_date`,
                                    {
                                      required: "Expiry Date is required",

                                      validate: (value) => {
                                        const expiryDate = new Date(value);

                                        const today = new Date();
                                        today.setHours(0, 0, 0, 0);

                                        const mfgDate = new Date(
                                          watch(`products.${index}.mfg_date`),
                                        );

                                        if (expiryDate <= today) {
                                          return "Expiry Date must be greater than today";
                                        }

                                        if (
                                          watch(`products.${index}.mfg_date`) &&
                                          expiryDate <= mfgDate
                                        ) {
                                          return "Expiry Date must be after Manufacturing Date";
                                        }

                                        return true;
                                      },
                                    },
                                  )}
                                />

                                {errors?.products?.[index]?.expiry_date && (
                                  <div className="invalid-feedback">
                                    {
                                      errors?.products?.[index]?.expiry_date
                                        ?.message
                                    }
                                  </div>
                                )}
                              </Form.Group>
                            </Row>
                          </div>
                        </Col>

                        {/* <VarientSection
                        product_id={getValues(`products.${index}.product_id`)}
                        variant_id={getValues(`products.${index}.variant_id`)}
                        Index={index}
                        control={control}
                        register={register}
                        getValues={getValues}
                        errors={errors}
                        setValue={setValue}
                      /> */}
                      </Row>
                      {/* {fields.length > 1 && (
                        <button
                          className="mt-3 add-varient"
                          type="button"
                          onClick={() => remove(index)} // Remove the variant
                        >
                          Remove Quantity
                        </button>
                      )} */}
                      <hr />
                    </div>
                  ))}
                  <Col md={6}>
                    <div className="main-form-section mt-3">
                      <Row className="justify-content-center">
                        <Form.Label>Remark</Form.Label>
                        <Form.Group>
                          <InputGroup>
                            <Form.Control
                              as="textarea"
                              rows={4}
                              name="remark"
                              placeholder="remark"
                              className={classNames("", {
                                "is-invalid": errors?.remark,
                              })}
                              {...register("remark", {
                                validate: (value) => {
                                  if (!value?.trim()) {
                                    return true;
                                  }

                                  return (
                                    value.length <= 200 ||
                                    "Data must be 200 characters or less"
                                  );
                                },
                              })}
                            />
                          </InputGroup>
                          {errors.remark && (
                            <span className="text-danger">
                              {errors.remark.message}
                            </span>
                          )}
                        </Form.Group>
                      </Row>
                    </div>
                  </Col>
                  {/* <div>Total Quantity:{totalQuantity}</div>
                <div>Total Price:{totalPrice}</div> */}
                </div>
                <hr />
                {/* <div className="text-center">
                  <button
                    type="button"
                    className="add-varient"
                    onClick={() => append({})}
                  >
                    + Add Quantity
                  </button>
                </div> */}
              </div>

              <Row className="mt-5 pb-3">
                <div className="d-flex justify-content-center">
                  <Link to={"/purchase-product/purchase-product"}>
                    <CancelButton
                      name={"cancel"}
                      handleClose={props.handleClose}
                    />
                  </Link>

                  <SaveButton
                    name={"save"}
                    loading={submitLoading}
                    handleSubmit={handleSubmit(onSubmit)}
                  />
                </div>
              </Row>
            </Row>
          </Form>
        )}
      </section>

      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
    </>
  );
};

export default EditOffCanvance;
